// include team's acronyms in the description for easier search

import { CanaryStoreEntry } from '@bill/canary.react'
import { themeOptions } from '@divvy-web/skylab.themeprovider'

const canaryConfig: CanaryStoreEntry[] = [
  {
    name: 'theme',
    variants: ['default', ...themeOptions],
    metadata: {
      description: 'GOLD: The theme to use for the application',
      icon: '🎨',
    },
    value: 'default',
  },
  {
    description: 'when enabled, show maintenance screen',
    name: 'sputnik-maint-mode',
    value: false,
  },
  {
    description: 'when enabled, shows aire theme',
    name: 'show-skylab-aire-theme',
    value: false,
  },
  {
    description: 'when enabled, shorten the time that the timeout warning modal is displayed and active to 15 seconds',
    name: 'reduceAccessTokenTimeout',
    value: false,
  },
  {
    description: 'when enabled, enables advanced onboarding return flow logic',
    name: 'advanced-onboarding-return-flow',
    value: false,
  },
  {
    description: 'COM: when enabled, show web bank changes',
    name: 'show-web-bank',
    value: false,
  },
  {
    description: 'COM: when enabled, show MFA logic',
    name: 'show-mfa-logic',
    value: false,
  },
  {
    description: 'COM: when enabled, show credit app dashboard redesign',
    name: 'rollout-credit-app-dashboard-redesign',
    value: false,
  },
  {
    name: 'beep-credit-application-review-page-collapsed-experiment',
    variants: [
      {
        behaviorName: 'sectionsExpanded',
        control: true,
        placement: 'QUALIFIED',
      },
      {
        behaviorName: 'sectionsCollapsed',
        placement: 'QUALIFIED',
      },
      {
        placement: 'NOT_QUALIFIED',
      },
      {
        placement: 'EXPERIMENT_OFF',
      },
    ],
    metadata: {
      description: 'COM: beep experiment attempt to collapse sections on the review page',
    },
  },
]

export default canaryConfig
